import styled, { css } from "styled-components";
import { useTranslationContext } from "../Hooks/useTranslationContext";

const Container = styled.div`
  display: flex;
  justify-content: end;
  margin-right: -0em;
  margin-left: 1em;
`;

const PointsElement = styled.div<{ points?: number }>`
  border-radius: 0.3em;
  padding: 0.6em;
  margin: 0.5em;
  font-size: 0.7em;
  margin-top: auto;
  margin-bottom: auto;
  text-align: center;
  font-weight: bold;

  ${({ points }) => {
    if (points === 2) {
      return css`
        background: var(--color-field-point-2);
      `;
    }
    if (points === 1) {
      return css`
        background: var(--color-field-point-1);
      `;
    }
    return css`
      background: var(--color-field-point-0);
    `;
  }}
`;

const PointsLegend = () => {
  const { t } = useTranslationContext();
  return (
    <Container>
      <PointsElement points={2}>{`2 ${t.points}`}</PointsElement>
      <PointsElement points={1}>{`1 ${t.points}`}</PointsElement>
      <PointsElement points={0}>{`0 ${t.points}`}</PointsElement>
    </Container>
  );
};
export default PointsLegend;
